<div class="tw-p-8 tw-max-w-7xl tw-mx-auto">
  <!-- Calendar Header -->
  <div class="tw-mb-8">
    <h2 class="tw-text-3xl tw-font-bold tw-text-gray-800 tw-m-0 tw-mb-2">Events Calendar</h2>
    <p class="tw-text-base tw-text-gray-600 tw-m-0">View and manage support requests for live and upcoming events</p>
  </div>

  <!-- Calendar Controls -->
  <div class="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-items-center tw-mb-6 tw-p-4 tw-bg-white tw-rounded-xl tw-shadow-sm tw-gap-4">
    <div>
      <h3 class="tw-text-2xl tw-font-semibold tw-text-gray-800 tw-m-0 tw-text-center md:tw-text-left">{{ getMonthYearText() }}</h3>
    </div>
    <div class="tw-flex tw-gap-2 tw-justify-center">
      <button
        class="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-border tw-border-gray-300 tw-rounded-lg tw-bg-white tw-text-gray-700 tw-text-sm tw-font-medium tw-cursor-pointer tw-transition-all hover:tw-bg-gray-50 hover:tw-border-gray-400 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
        (click)="previousMonth()"
        [disabled]="loading()"
      >
        <svg viewBox="0 0 24 24" class="tw-w-5 tw-h-5">
          <path fill="currentColor" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
        </svg>
        Previous
      </button>
      <button
        class="tw-px-4 tw-py-2 tw-border tw-border-blue-500 tw-rounded-lg tw-bg-blue-500 tw-text-white tw-text-sm tw-font-medium tw-cursor-pointer tw-transition-all hover:tw-bg-blue-600 hover:tw-border-blue-600 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
        (click)="goToToday()"
        [disabled]="loading()"
      >
        Today
      </button>
      <button
        class="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-border tw-border-gray-300 tw-rounded-lg tw-bg-white tw-text-gray-700 tw-text-sm tw-font-medium tw-cursor-pointer tw-transition-all hover:tw-bg-gray-50 hover:tw-border-gray-400 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
        (click)="nextMonth()"
        [disabled]="loading()"
      >
        Next
        <svg viewBox="0 0 24 24" class="tw-w-5 tw-h-5">
          <path fill="currentColor" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Loading Indicator -->
  @if (loading()) {
  <div class="tw-relative tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-12 tw-bg-white tw-rounded-xl tw-shadow-sm tw-mb-6">
    <div class="spinner"></div>
    <p class="tw-mt-4 tw-text-gray-600 tw-text-sm">Loading events...</p>
  </div>
  } @else {
  <div class="calendar-wrapper tw-bg-white tw-rounded-xl tw-p-6 tw-shadow-sm tw-mb-6">
    <full-calendar #calendar [options]="calendarOptions"></full-calendar>
  </div>
  }

  <!-- Legend -->
  <div class="tw-flex tw-flex-col sm:tw-flex-row tw-gap-8 sm:tw-gap-8 tw-justify-center tw-items-center tw-p-4 tw-bg-white tw-rounded-xl tw-shadow-sm">
    <div class="tw-flex tw-items-center tw-gap-2">
      <span class="tw-w-5 tw-h-5 tw-rounded tw-bg-green-500"></span>
      <span class="tw-text-sm tw-text-gray-700 tw-font-medium">Live Events</span>
    </div>
    <div class="tw-flex tw-items-center tw-gap-2">
      <span class="tw-w-5 tw-h-5 tw-rounded tw-bg-blue-500"></span>
      <span class="tw-text-sm tw-text-gray-700 tw-font-medium">Upcoming Events</span>
    </div>
  </div>

  <!-- Support Request Modal -->
  <ngx-support-request-modal [event]="selectedEvent()" (modalClosed)="onModalClose()"></ngx-support-request-modal>
</div>
